import React, { Component, ReactNode } from "react";

import UncaughtError from "./components/UncaughtError";

interface Props {
  children?: ReactNode;
}

interface State {
  shouldHandleError: boolean;
  error: Error | null;
}

class GlobalErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      shouldHandleError: false,
      error: null,
    };
  }

  public static getDerivedStateFromError(error: Error): State {
    return {
      shouldHandleError: true,
      error,
    };
  }

  public render() {
    const { shouldHandleError, error } = this.state;
    const { children } = this.props;

    if (!shouldHandleError) {
      return children;
    }

    if (shouldHandleError) {
      return (
        <UncaughtError
          error={error}
          handleButtonClick={() => {
            this.setState({
              shouldHandleError: false,
              error: null,
            });
          }}
        />
      );
    }
    return children;
  }
}

export default GlobalErrorBoundary;
